// import { useEffect } from "react";
// import {  useLocation, useNavigate } from "react-router-dom";
// import qs from "qs";
// // import { enqueueSnackbar } from "notistack";
// import { http } from "../../../../service/http";
// import { SUCCESS_CODE } from "../../../../service/ServiceConstants";
// import { setSingleAlertObj } from "../../../../redux/slice/commonSlice";
// import { useAppDispatch } from "../../../../redux/slice/redux-hooks";
// import { Link } from "@mui/material";

// export default function StripePaymentVerifySession() {
//   const navigate = useNavigate();
//   const { search } = useLocation();
//   const dispatch = useAppDispatch();
//   useEffect(() => {
//     const { status, session_id, from } = qs.parse(search.slice(1));
//     const goBackTo = typeof from === "string" && from ? decodeURIComponent(from) : "/";

//     const finish = (variant: "error" | "success" | "warning" | "info", msg: string | JSX.Element , data?:any) => {
//       if(data && data?.data?.invoice_number){
//         dispatch(setSingleAlertObj({ message: msg, alertType: variant }));
//         return navigate("/invoice_list", { state: { mfgInvoiceNumber: data?.data?.invoice_number } });
//       } else {
//         return navigate(goBackTo,{replace: true});
//       }
//     };

//     if (status === "cancel" || !session_id) {
//         return finish("info", "Payment process was cancelled.");
//     }

//     http.get(`/stripepaymentservice/verify-session/${session_id}`)
//       .then(({ data }) => {
//         console.log("%c Line:34 🥟 data", "color:#fca650", data);
//         if (data?.code === SUCCESS_CODE && data?.data?.payment_status === "unpaid") {
//           const successMessage = (
//             <>
//               Payment for invoice{' '}
//               <Link
//                 component="button"
//                 underline="hover"
//                 variant="body2"
//                 onClick={() => {
//                   navigate("/invoice_list", { state: { mfgInvoiceNumber: data?.data?.invoice_number } });
//                 }}
//                 color="white"
//               >
//                 {data?.data?.invoice_number}
//               </Link>{' '}
//               is processing and may take a few business days to complete.
//             </>
//           );
//           return finish("warning", successMessage, data);
//           // dispatch(setSingleAlertObj({ message: successMessage, alertType: 'warning' }));

//           // const ok = data?.status === "complete" && (data?.payment_status === "paid" || data?.payment_status === "no_payment_required");
//           // if (ok) finish("warning", successMessage,data);
//           // else finish("error", "Payment not completed.");
//         } else {
//           finish("error", "Something went wrong while verifying payment.")
//         }
//       })
//       .catch((err:any) => {
//         let errorMessage = "Something went wrong while verifying payment.";
//         dispatch(setSingleAlertObj({ message: errorMessage, alertType: 'error' }));
//         finish("error", "Could not verify payment.");
//       });
//   }, [search, navigate]);

//   return null;
// }
import { useEffect } from "react";
import {  useLocation, useNavigate } from "react-router-dom";
import qs from "qs";
// import { enqueueSnackbar } from "notistack";
import { http } from "../../../../service/http";
import { SUCCESS_CODE } from "../../../../service/ServiceConstants";
import { setSingleAlertObj } from "../../../../redux/slice/commonSlice";
import { useAppDispatch } from "../../../../redux/slice/redux-hooks";
import { Link } from "@mui/material";
import { expireStripeCheckoutSession } from "../../../../redux/slice/invoice/InvoiceSlice";
import { tr } from "date-fns/locale";
import { fetchOrderById } from "../../../../redux/slice/order/OrderSlice";

export default function StripePaymentVerifySession() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const { status, session_id, from, entityId, entityNumber , paymentMethod ,manufacturerId , transactionId, orderId, upfrontPayment } = qs.parse(search.slice(1));

    const goBackTo =
    typeof from === "string" && from ? decodeURIComponent(from) : "/";

    // Normalize to strings
    const invNumber = typeof entityNumber === "string" ? entityNumber : "";
    const invId = typeof entityId === "string" ? entityId : undefined;
    const trasactionId = typeof transactionId === "string" ? transactionId : undefined;
    const normalizedOrderId = typeof orderId === "string" ? orderId : undefined;
    const normalizedUpfrontPayment = typeof upfrontPayment === "string" ? upfrontPayment : undefined;
    const finish = (
      variant: "error" | "success" | "warning" | "info",
      msg: string | JSX.Element,
      data?: any
    ) => {
      if (data && from === "/invoice_list") {
        dispatch(setSingleAlertObj({ message: msg, alertType: variant }));
        return navigate("/invoice_list", { replace: true, state: { mfgInvoiceNumber: data } });
      }if (data && from === "/payment_list") {
        dispatch(setSingleAlertObj({ message: msg, alertType: variant }));
        return navigate("/payment_list", { replace: true, state: { paymentListSearchCriteria: data } })
      }else if( data && from==="/billing_detail"){
        dispatch(setSingleAlertObj({ message: msg, alertType: variant }));
        return navigate("/billing_detail", { replace: true, state: { invoiceId: invId } });
      }else if( data && from==="/order_list" && normalizedUpfrontPayment === "true" && data.orderId){
        dispatch(setSingleAlertObj({ message: msg, alertType: variant }));
        dispatch(fetchOrderById({ orderId: Number(data.orderId), isSaveAuditLog: false }))
        .then((result: any) => {
          const orderData = result?.payload?.data;
          if (orderData) {
            return navigate("/details/1", { replace: true, state: { orderDetails: orderData, fromStripeOrderPayment: true } });
          } else {
            return navigate("/order_list", { replace: true });
          }
        });
      } else {
        // Stale Stripe URLs sit above this entry in history; flag billing_detail so its Back skips them.
        const isBillingDetailFallback = goBackTo === "/billing_detail";
        if (invId) {
          return navigate(goBackTo, {
            replace: true,
            state: isBillingDetailFallback
              ? { invoiceId: invId, fromStripeCancel: true }
              : { invoiceId: invId },
          });
        }
        if (isBillingDetailFallback) {
          return navigate(goBackTo, { replace: true, state: { fromStripeCancel: true } });
        }
        return navigate(goBackTo, { replace: true });
      }
    };

    if (status === "success" && session_id && trasactionId  && paymentMethod === "US_BANK_ACCOUNT") {
      let Data={
        isStripeCall:true,
        sessionId:session_id,
        stripePaymentMethod:paymentMethod,
        transactionId:trasactionId,
        orderId:orderId
      }
      const successMessage = (
        <>
          Payment for transaction{" "}
          <Link
            component="button"
            underline="hover"
            variant="body2"
            onClick={() =>
              navigate("/payment_list", { state: { paymentListSearchCriteria: Data } })
            }
            color="white"
          >
            {trasactionId}
          </Link>{" "}
          is processing and may take a few business days to complete.
        </>
      );
      return finish("warning", successMessage, Data);
    }
    //CS-1513 
    if (status === "success" && session_id && trasactionId && paymentMethod === "CARD") {
      let Data={
        isStripeCall:true,
        sessionId:session_id,
        stripePaymentMethod:paymentMethod,
        transactionId:trasactionId,
        orderId:orderId
      }
      const successMessage = (
        <>
          Payment for transaction{" "}
          <Link
            component="button"
            underline="hover"
            variant="body2"
            onClick={() =>
              navigate("/payment_list", { state: { paymentListSearchCriteria: Data } })
            }
            color="white"
          >
            {trasactionId}
          </Link>{" "}
          is processed successfully.
        </>
      );
      return finish("success", successMessage, Data);
    }

    if (status === "cancel" || session_id) {
      //CS-1576 - Dispatch expire session action to handle connected accounts also
      const data={
        sessionId: session_id,
        manufacturerId:Number(manufacturerId),
        transactionId:trasactionId
      }
      
      // Add orderId and upfrontPayment if present in URL
      if (normalizedOrderId) {
        (data as any).orderId = Number(normalizedOrderId);
      }
      if (normalizedUpfrontPayment) {
        (data as any).upfrontPayment = normalizedUpfrontPayment === 'true';
      }
      
     dispatch(expireStripeCheckoutSession(data));
    }

    return finish("error", "Could not verify payment.");
  }, [search, navigate, dispatch]);

  return null;
}

